<template>
    <div class="container admin-table-page">
        <div class="param-title-wrap plan-consolidacion-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>

        <div class="param-title-wrap plan-consolidacion-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <b-form-select
                        id="report-select"
                        v-model="selReporte"
                        @change="resetAllData"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>
                        <option v-for="reporte in listaReporte" :key="reporte?.id" :value="reporte?.codigo">
                            {{ reporte?.nombre }}
                        </option>
                    </b-form-select>

                    <b-button
                        class="consult-btn ml-2"
                        @click="consultData"
                        :disabled="!selReporte"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>

        <div class="admin-table-block mt-4" v-if="!isLoading">
            <CorporateDataTable
                :items="tableItems"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                :show-search="true"
                :allow-column-toggle="true"
                :enable-sorting="true"
                :toolbar-disabled="!fgl_consulta"
            >
                <template #toolbar-actions>
                    <div class="plan-consolidacion-toolbar-right">
                        <b-button
                            size="sm"
                            class="table-toolbar-add-btn"
                            @click="openCreateModal"
                            :disabled="!fgl_consulta"
                        >
                            <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />
                            {{ labels.create }}
                        </b-button>
                    </div>
                </template>

                <template #cell(nivel)="data">
                    <div class="text-left">
                        {{ data.item.nivel }}
                    </div>
                </template>

                <template #cell(codigo)="data">
                    <div class="text-left"><strong>{{ data.item.codigo }}</strong></div>
                </template>

                <template #cell(descripcion)="data">
                    <div class="text-left">{{ data.item.descripcion }}</div>
                </template>

                <template #cell(perteneceA)="data">
                    <div class="text-left">{{ data.item.perteneceA || '-' }}</div>
                </template>

                <template #cell(accionEdit)="data">
                    <b-button
                        style="background-color: #FF924C; width: 30px; height: 30px;"
                        class="md-fab md-primary table-action-btn"
                        @click.stop="openEditModal(data.item)"
                        :disabled="!fgl_consulta"
                    >
                        <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>

        <div v-if="isLoading" class="text-center py-5">
            <b-spinner></b-spinner>
            <p class="mt-2">{{ labels.loading }}</p>
        </div>

        <!-- Modal Unificado para Crear Nivel -->
        <b-modal
            :model-value="showCreateModal"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.createLevel"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-level-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.selectLevel }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select 
                            v-model="selectedLevel"
                            class="form-input"
                            @change="onLevelChange"
                        >
                            <option value="" disabled>Seleccione un nivel</option>
                            <option value="1">{{ labels.level1 }}</option>
                            <option value="2" :disabled="listaPrimerNivel.length === 0">{{ labels.level2 }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <template v-if="selectedLevel == 1">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.levelFirst }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="levelFirstData.codigo" 
                                type="text" 
                                class="form-input" 
                                autocomplete="off"
                                :placeholder="labels.levelFirstPlaceholder"
                                @keypress="onlyNumbers"
                                @input="checkCreateChanges"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.name }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="levelFirstData.descripcion" 
                                type="text" 
                                class="form-input" 
                                autocomplete="off"
                                :placeholder="labels.namePlaceholder"
                                @input="checkCreateChanges"
                            />
                        </b-col>
                    </b-row>
                </template>

                <template v-if="selectedLevel == 2">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.belongsTo }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select 
                                v-model="levelSecondData.primerNivel"
                                class="form-input"
                                @change="checkCreateChanges"
                            >
                                <option value="" disabled>Seleccione un nivel 1</option>
                                <option
                                    v-for="nivel in listaPrimerNivel"
                                    :key="nivel.id"
                                    :value="nivel.primer_nivel"
                                >
                                    {{ nivel.primer_nivel }} - {{ nivel.descripcion }}
                                </option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.levelSecond }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="levelSecondData.codigo" 
                                type="text" 
                                class="form-input" 
                                autocomplete="off"
                                :placeholder="labels.levelSecondPlaceholder"
                                @keypress="onlyNumbersAndDot"
                                @input="checkCreateChanges"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.name }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="levelSecondData.descripcion" 
                                type="text" 
                                class="form-input" 
                                autocomplete="off"
                                :placeholder="labels.namePlaceholder"
                                @input="checkCreateChanges"
                            />
                        </b-col>
                    </b-row>
                </template>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeCreateModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="confirmCreate" :disabled="!selectedLevel || !isFormValid || !hasCreateChanges">
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal Unificado para Editar Nivel -->
        <b-modal
            :model-value="showEditModal"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.editLevel"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-level-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.editInfoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.editInfoText }}</div>
                </div>

                <template v-if="editData.tipo == 'primero'">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.levelFirst }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="editData.codigo" 
                                type="text" 
                                class="form-input" 
                                autocomplete="off"
                                :placeholder="labels.levelFirstPlaceholder"
                                @keypress="onlyNumbers"
                                @input="checkEditChanges"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.name }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="editData.descripcion" 
                                type="text" 
                                class="form-input" 
                                autocomplete="off"
                                :placeholder="labels.namePlaceholder"
                                @input="checkEditChanges"
                            />
                        </b-col>
                    </b-row>
                </template>

                <template v-if="editData.tipo == 'segundo'">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.belongsTo }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select 
                                v-model="editData.primerNivel"
                                class="form-input"
                                @change="checkEditChanges"
                            >
                                <option value="" disabled>Seleccione un nivel 1</option>
                                <option
                                    v-for="nivel in listaPrimerNivel"
                                    :key="nivel.id"
                                    :value="nivel.primer_nivel"
                                >
                                    {{ nivel.primer_nivel }} - {{ nivel.descripcion }}
                                </option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.levelSecond }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="editData.codigo" 
                                type="text" 
                                class="form-input" 
                                autocomplete="off"
                                :placeholder="labels.levelSecondPlaceholder"
                                @keypress="onlyNumbersAndDot"
                                @input="checkEditChanges"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.name }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="editData.descripcion" 
                                type="text" 
                                class="form-input" 
                                autocomplete="off"
                                :placeholder="labels.namePlaceholder"
                                @input="checkEditChanges"
                            />
                        </b-col>
                    </b-row>
                </template>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeEditModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="confirmEdit" :disabled="!hasEditChanges">
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal de Confirmación -->
        <b-modal
            :model-value="showConfirmModal"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="md"
            :title="confirmLabels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog confirm-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ confirmLabels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ confirmLabels.infoText }}</div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeConfirmModal">
                        {{ confirmLabels.cancel }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="executeAction">
                        {{ confirmLabels.confirm }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PrimerNivel from "../../services/PrimerNivel"
import SegundoNivel from "../../services/SegundoNivel"
import TipoReporte from "../../services/TipoReporte"
import CorporateDataTable from "../utils/CorporateDataTable.vue"

export default {
    name: "PlanConsolidacion",
    components: {
        CorporateDataTable
    },
    data: () => ({
        listaPrimerNivel: [],
        selPrimerLev: "",
        listSegundoNivel: [],
        selSegundoLev: "",
        showCreateModal: false,
        showEditModal: false,
        fgl_consulta: false,
        isLoading: false,
        listaReporte: [],
        selReporte: '',
        codReporte: '',
        selectedLevel: '',
        levelFirstData: {
            codigo: '',
            descripcion: ''
        },
        levelSecondData: {
            primerNivel: '',
            codigo: '',
            descripcion: ''
        },
        editData: {
            id: '',
            tipo: '',
            codigo: '',
            descripcion: '',
            primerNivel: '',
            segundoNivel: '',
            codigoOriginal: '',
            descripcionOriginal: '',
            primerNivelOriginal: ''
        },
        hasEditChanges: false,
        hasCreateChanges: false,
        showConfirmModal: false,
        pendingAction: null,
        pendingType: null
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Esquema de consolidación",
                    selectReport: "Seleccione Reporte",
                    consultar: "Consultar",
                    create: "Crear",
                    createLevel: "Crear Nivel",
                    editLevel: "Editar Nivel",
                    selectLevel: "Seleccionar Nivel",
                    level1: "Nivel 1",
                    level2: "Nivel 2",
                    levelFirst: "Código Nivel 1",
                    levelSecond: "Código Nivel 2",
                    belongsTo: "Pertenece a",
                    name: "Nombre",
                    save: "Guardar",
                    close: "Cerrar",
                    infoTitle: "Información del nivel",
                    infoText: "Selecciona el nivel que deseas crear y completa la información.",
                    editInfoTitle: "Editar nivel",
                    editInfoText: "Modifica los campos que deseas actualizar y guarda los cambios.",
                    levelFirstPlaceholder: "Ej: 1, 2, 3...",
                    levelSecondPlaceholder: "Ej: 1.1, 1.2, 2.1...",
                    namePlaceholder: "Nombre del nivel",
                    noData: "No hay datos disponibles",
                    selectFilters: "Seleccione un reporte y consulte la información",
                    loading: "Cargando...",
                    nivel: "Nivel",
                    codigo: "Código",
                    descripcion: "Descripción",
                    perteneceA: "Pertenece a",
                    edit: "Editar",
                    noMatches: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    filterNivel: "Filtrar nivel...",
                    filterCodigo: "Filtrar código...",
                    filterDescripcion: "Filtrar descripción...",
                    filterPertenece: "Filtrar pertenece a..."
                }
            } else {
                return {
                    title: "Consolidation Schedule",
                    selectReport: "Select Report",
                    consultar: "Consult",
                    create: "Create",
                    createLevel: "Create Level",
                    editLevel: "Edit Level",
                    selectLevel: "Select Level",
                    level1: "Level 1",
                    level2: "Level 2",
                    levelFirst: "Level 1 Code",
                    levelSecond: "Level 2 Code",
                    belongsTo: "Belongs to",
                    name: "Name",
                    save: "Save",
                    close: "Close",
                    infoTitle: "Level information",
                    infoText: "Select the level you want to create and complete the information.",
                    editInfoTitle: "Edit level",
                    editInfoText: "Modify the fields you want to update and save the changes.",
                    levelFirstPlaceholder: "Ex: 1, 2, 3...",
                    levelSecondPlaceholder: "Ex: 1.1, 1.2, 2.1...",
                    namePlaceholder: "Level name",
                    noData: "No data available",
                    selectFilters: "Select a report and consult the information",
                    loading: "Loading...",
                    nivel: "Level",
                    codigo: "Code",
                    descripcion: "Description",
                    perteneceA: "Belongs to",
                    edit: "Edit",
                    noMatches: "No results found",
                    searchPlaceholder: "Search in table...",
                    rowsPerPage: "Rows per page:",
                    noSort: "No sorting",
                    sortAsc: "A-Z / Low to high",
                    sortDesc: "Z-A / High to low",
                    columns: "Columns",
                    showAllColumns: "Show all",
                    filters: "Filters",
                    clearFilters: "Clear filters",
                    filterNivel: "Filter level...",
                    filterCodigo: "Filter code...",
                    filterDescripcion: "Filter description...",
                    filterPertenece: "Filter belongs to..."
                }
            }
        },
        confirmLabels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Confirmar acción",
                    infoTitle: "¿Está seguro?",
                    infoText: this.pendingAction === 'save' 
                        ? "¿Está seguro que desea guardar los cambios?" 
                        : "¿Está seguro que desea cerrar sin guardar los cambios?",
                    confirm: "Confirmar",
                    cancel: "Cancelar"
                }
            } else {
                return {
                    title: "Confirm action",
                    infoTitle: "Are you sure?",
                    infoText: this.pendingAction === 'save' 
                        ? "Are you sure you want to save the changes?" 
                        : "Are you sure you want to close without saving?",
                    confirm: "Confirm",
                    cancel: "Cancel"
                }
            }
        },
        allFields() {
            return [
                { key: 'nivel', label: this.labels.nivel, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'codigo', label: this.labels.codigo, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'perteneceA', label: this.labels.perteneceA, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'nivel', type: 'text', placeholder: this.labels.filterNivel },
                { key: 'codigo', type: 'text', placeholder: this.labels.filterCodigo },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion },
                { key: 'perteneceA', type: 'text', placeholder: this.labels.filterPertenece }
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        tableItems() {
            const items = []
            
            this.listaPrimerNivel.forEach(item => {
                items.push({
                    id: item.id,
                    nivel: 'Nivel 1',
                    codigo: item.primer_nivel,
                    descripcion: item.descripcion,
                    perteneceA: '-',
                    tipo: 'primero',
                    data: item,
                    primer_nivel: item.primer_nivel
                })
            })
            
            this.listSegundoNivel.forEach(item => {
                const padre = this.listaPrimerNivel.find(p => p.primer_nivel == item.primer_nivel)
                const perteneceA = padre ? `${padre.primer_nivel} - ${padre.descripcion}` : item.primer_nivel
                
                items.push({
                    id: item.id,
                    nivel: 'Nivel 2',
                    codigo: item.segundo_nivel,
                    descripcion: item.descripcion,
                    perteneceA: perteneceA,
                    tipo: 'segundo',
                    data: item,
                    primer_nivel: item.primer_nivel,
                    segundo_nivel: item.segundo_nivel
                })
            })
            
            return items
        },
        isFormValid() {
            if (this.selectedLevel == 1) {
                return this.levelFirstData.codigo && this.levelFirstData.descripcion
            } else if (this.selectedLevel == 2) {
                return this.levelSecondData.primerNivel && 
                       this.levelSecondData.codigo && 
                       this.levelSecondData.descripcion
            }
            return false
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },

        onlyNumbers(event) {
            const key = event.key
            if (!/^[0-9]$/.test(key)) {
                event.preventDefault()
            }
        },

        onlyNumbersAndDot(event) {
            const key = event.key
            const value = event.target.value
            if (!/^[0-9.]$/.test(key)) {
                event.preventDefault()
            }
            if (key === '.' && value.includes('.')) {
                event.preventDefault()
            }
        },

        resetAllData() {
            this.fgl_consulta = false
            this.listaPrimerNivel = []
            this.listSegundoNivel = []
            this.selPrimerLev = ''
            this.selSegundoLev = ''
        },

        consultData() {
            if (!this.selReporte) {
                this.$toast.error('Seleccionar un reporte')
                return
            }
            
            this.isLoading = true
            this.resetAllData()

            PrimerNivel.getFirstLevelByReporte(this.selReporte)
                .then((res) => {
                    this.listaPrimerNivel = res.data.firstLevByReport
                    this.fgl_consulta = true
                    return SegundoNivel.getAllLevelSecond(this.selReporte)
                })
                .then((res) => {
                    this.listSegundoNivel = res.data.segundoNivel
                })
                .catch((error) => {
                    console.log(error)
                    this.$toast.error('Error al consultar los niveles')
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        // ========== MÉTODOS DE CREACIÓN ==========
        openCreateModal() {
            if (this.listaPrimerNivel.length === 0) {
                this.selectedLevel = '1'
            } else {
                this.selectedLevel = ''
            }
            this.hasCreateChanges = false
            this.showCreateModal = true
            this.resetFormData()
        },

        onLevelChange() {
            this.hasCreateChanges = false
            this.resetFormData()
        },

        resetFormData() {
            this.levelFirstData = {
                codigo: '',
                descripcion: ''
            }
            this.levelSecondData = {
                primerNivel: '',
                codigo: '',
                descripcion: ''
            }
        },

        checkCreateChanges() {
            if (this.selectedLevel == 1) {
                this.hasCreateChanges = this.levelFirstData.codigo !== '' || this.levelFirstData.descripcion !== ''
            } else if (this.selectedLevel == 2) {
                this.hasCreateChanges = this.levelSecondData.primerNivel !== '' || 
                                        this.levelSecondData.codigo !== '' || 
                                        this.levelSecondData.descripcion !== ''
            }
        },

        closeCreateModal() {
            if (this.hasCreateChanges && this.isFormValid) {
                this.pendingAction = 'close'
                this.pendingType = 'create'
                this.showConfirmModal = true
            } else {
                this.showCreateModal = false
                this.selectedLevel = ''
                this.resetFormData()
                this.hasCreateChanges = false
            }
        },

        confirmCreate() {
            this.pendingAction = 'save'
            this.pendingType = 'create'
            this.showConfirmModal = true
        },

        // ========== MÉTODOS DE EDICIÓN ==========
        openEditModal(item) {
            if (item.tipo == 'primero') {
                this.editData = {
                    id: item.id,
                    tipo: 'primero',
                    codigo: item.codigo,
                    descripcion: item.descripcion,
                    primerNivel: '',
                    segundoNivel: '',
                    codigoOriginal: item.codigo,
                    descripcionOriginal: item.descripcion,
                    primerNivelOriginal: ''
                }
            } else if (item.tipo == 'segundo') {
                this.editData = {
                    id: item.id,
                    tipo: 'segundo',
                    codigo: item.codigo,
                    descripcion: item.descripcion,
                    primerNivel: item.primer_nivel,
                    segundoNivel: item.segundo_nivel,
                    codigoOriginal: item.codigo,
                    descripcionOriginal: item.descripcion,
                    primerNivelOriginal: item.primer_nivel
                }
            }
            this.hasEditChanges = false
            this.showEditModal = true
        },

        checkEditChanges() {
            if (this.editData.tipo == 'primero') {
                this.hasEditChanges = 
                    this.editData.codigo !== this.editData.codigoOriginal ||
                    this.editData.descripcion !== this.editData.descripcionOriginal
            } else if (this.editData.tipo == 'segundo') {
                this.hasEditChanges = 
                    this.editData.codigo !== this.editData.codigoOriginal ||
                    this.editData.descripcion !== this.editData.descripcionOriginal ||
                    this.editData.primerNivel !== this.editData.primerNivelOriginal
            }
        },

        closeEditModal() {
            if (this.hasEditChanges) {
                this.pendingAction = 'close'
                this.pendingType = 'edit'
                this.showConfirmModal = true
            } else {
                this.showEditModal = false
                this.hasEditChanges = false
                this.editData = {
                    id: '',
                    tipo: '',
                    codigo: '',
                    descripcion: '',
                    primerNivel: '',
                    segundoNivel: '',
                    codigoOriginal: '',
                    descripcionOriginal: '',
                    primerNivelOriginal: ''
                }
            }
        },

        confirmEdit() {
            this.pendingAction = 'save'
            this.pendingType = 'edit'
            this.showConfirmModal = true
        },

        // ========== MÉTODOS DE CONFIRMACIÓN ==========
        closeConfirmModal() {
            this.showConfirmModal = false
            this.pendingAction = null
            this.pendingType = null
        },

        executeAction() {
            this.showConfirmModal = false
            const action = this.pendingAction
            const type = this.pendingType
            this.pendingAction = null
            this.pendingType = null

            if (action === 'save') {
                if (type === 'create') {
                    this.saveLevel()
                } else if (type === 'edit') {
                    this.saveEdit()
                }
            } else if (action === 'close') {
                if (type === 'create') {
                    this.showCreateModal = false
                    this.selectedLevel = ''
                    this.resetFormData()
                    this.hasCreateChanges = false
                } else if (type === 'edit') {
                    this.showEditModal = false
                    this.hasEditChanges = false
                    this.editData = {
                        id: '',
                        tipo: '',
                        codigo: '',
                        descripcion: '',
                        primerNivel: '',
                        segundoNivel: '',
                        codigoOriginal: '',
                        descripcionOriginal: '',
                        primerNivelOriginal: ''
                    }
                }
            }
        },

        saveLevel() {
            if (this.selectedLevel == 1) {
                this.saveLevelFirst()
            } else if (this.selectedLevel == 2) {
                this.saveLevelSecond()
            }
        },

        saveLevelFirst() {
            let form = {
                'primer_nivel': this.levelFirstData.codigo,
                'descripcion': this.levelFirstData.descripcion,
                'codReporte': this.selReporte,
                'idUser': this.$store.state.userId,
            }
            
            PrimerNivel.createLevelFirst(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.showCreateModal = false
                    this.selectedLevel = ''
                    this.resetFormData()
                    this.hasCreateChanges = false
                    this.refreshData()
                })
                .catch((err) => {
                    this.$toast.error(err.response?.data?.message || err.message || 'Error al crear el nivel')
                    console.log(err)
                })
        },

        saveLevelSecond() {
            let form = {
                'primer_nivel': this.levelSecondData.primerNivel,
                'segundo_nivel': this.levelSecondData.codigo,
                'descripcion': this.levelSecondData.descripcion,
                'codReporte': this.selReporte,
                'idUser': this.$store.state.userId,
            }
            
            SegundoNivel.createSecondLevel(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.showCreateModal = false
                    this.selectedLevel = ''
                    this.resetFormData()
                    this.hasCreateChanges = false
                    this.refreshData()
                })
                .catch((err) => {
                    this.$toast.error(err.response?.data?.message || err.message || 'Error al crear el nivel')
                    console.log(err)
                })
        },

        saveEdit() {
            if (this.editData.tipo == 'primero') {
                this.updateLevelFirst()
            } else if (this.editData.tipo == 'segundo') {
                this.updateLevelSecond()
            }
        },

        updateLevelFirst() {
            let form = {
                'id': this.editData.id,
                'primer_nivel': this.editData.codigo,
                'descripcion': this.editData.descripcion,
                'codReporte': this.selReporte,
                'idUser': this.$store.state.userId,
            }
            
            PrimerNivel.updatePrimerNivel(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.showEditModal = false
                    this.hasEditChanges = false
                    this.editData = {
                        id: '',
                        tipo: '',
                        codigo: '',
                        descripcion: '',
                        primerNivel: '',
                        segundoNivel: '',
                        codigoOriginal: '',
                        descripcionOriginal: '',
                        primerNivelOriginal: ''
                    }
                    this.refreshData()
                })
                .catch((err) => {
                    this.$toast.error(err.response?.data?.message || err.message || 'Error al actualizar el nivel')
                    console.log(err)
                })
        },

        updateLevelSecond() {
            let form = {
                'id': this.editData.id,
                'primer_nivel': this.editData.primerNivel,
                'segundo_nivel': this.editData.codigo,
                'descripcion': this.editData.descripcion,
                'codReporte': this.selReporte,
                'idUser': this.$store.state.userId,
            }
            
            SegundoNivel.updateSegundoNivel(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.showEditModal = false
                    this.hasEditChanges = false
                    this.editData = {
                        id: '',
                        tipo: '',
                        codigo: '',
                        descripcion: '',
                        primerNivel: '',
                        segundoNivel: '',
                        codigoOriginal: '',
                        descripcionOriginal: '',
                        primerNivelOriginal: ''
                    }
                    this.refreshData()
                })
                .catch((err) => {
                    this.$toast.error(err.response?.data?.message || err.message || 'Error al actualizar el nivel')
                    console.log(err)
                })
        },

        refreshData() {
            this.isLoading = true
            
            Promise.all([
                PrimerNivel.getFirstLevelByReporte(this.selReporte),
                SegundoNivel.getAllLevelSecond(this.selReporte)
            ])
            .then(([res1, res2]) => {
                this.listaPrimerNivel = res1.data.firstLevByReport
                this.listSegundoNivel = res2.data.segundoNivel
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                this.isLoading = false
            })
        }
    },
    mounted() {
        this.isLoading = true
        TipoReporte.getAllTipoReporte()
            .then((res) => {
                this.listaReporte = res.data.typeReport
            })
            .catch((error) => console.log(error))
            .finally(() => {
                this.isLoading = false
            })
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
.plan-consolidacion-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.plan-consolidacion-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.plan-consolidacion-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.plan-consolidacion-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.plan-consolidacion-header .consult-btn:hover,
.plan-consolidacion-header .consult-btn:focus,
.plan-consolidacion-header .consult-btn:active,
.plan-consolidacion-header .consult-btn:not(:disabled):hover,
.plan-consolidacion-header .consult-btn:not(:disabled):focus,
.plan-consolidacion-header .consult-btn:not(:disabled):active {
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
    box-shadow: none !important;
}

.plan-consolidacion-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background-color: #6c757d !important;
    color: white !important;
    border-color: #6c757d !important;
}

.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

.plan-consolidacion-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.table-toolbar-add-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #2e507a;
    color: white;
    border: 1px solid #2e507a;
}

.table-toolbar-add-btn:hover:not(:disabled) {
    background-color: #1e3a5f;
    border-color: #1a3455;
    color: white;
}

.table-toolbar-add-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    background-color: #2e507a;
    border-color: #2e507a;
    color: white;
}

@media (max-width: 1200px) {
    .plan-consolidacion-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }
    
    .plan-consolidacion-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 992px) {
    .plan-consolidacion-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }
    
    .plan-consolidacion-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }
    
    .plan-consolidacion-header .consult-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }
    
    .plan-consolidacion-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }
    
    .plan-consolidacion-header .filters-container {
        gap: 4px;
    }
    
    .plan-consolidacion-header .consult-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
    }
}
</style>